import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/devg_site.png";
import projImg2 from "../assets/img/DevDetectpr.png";
import projImg3 from "../assets/img/weather.png";
// import projImg4 from "../assets/img/razor.png";
import projImg6 from "../assets/img/courseVerse.png";
import projImg7 from "../assets/img/chatApp.jpg";
import projImg8 from "../assets/img/linktree.png";
import wallet from "../assets/img/wallet.png";
import solana from "../assets/img/solana.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import lifeyear from "../assets/img/lifeyear.jpeg";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "DEV-G, edtech website",
      description: "Rectjs, Expressjs, Nodejs & MongoDB",
      imgUrl: projImg1,
      github: "https://github.com/ashutoshgithubs/iemhacks_DEV-G",
      link: "https://edtech-dev-g-frontend.vercel.app/",
    },
    {
      title: "Linktree - Manage social media links",
      description: "Next.js, Express.js, MongoDB",
      imgUrl: projImg8,
      github: "https://github.com/ashutoshgithubs/linktree",
      link: "https://linktree-lovat-mu.vercel.app/",
    },
    {
      title: "Solana Token Launchpad",
      description:
        "Airdrop & Send SOL, Generate token mint, Liquidity Pool & Swap Token",
      imgUrl: solana,
      github: "https://github.com/",
      link: "https://launchpadsolana-tokens.vercel.app/",
    },
  ];
  const projects2 = [
    {
      title: "Blockchain Wallet",
      description: "@solana/web3.js, ethers.js,React, Mnemonics, HD Wallets",
      imgUrl: wallet,
      github: "https://github.com/ashutoshgithubs/Web-Wallet",
      link: "https://ashutosh-crypto-wallet.vercel.app/",
    },
    {
      title: "Life.log",
      description: "Groq AI, React.js, Node.js, Express.js, MongoDB",
      imgUrl: lifeyear,
      github: "https://github.com/ashutoshgithubs/life.log",
      link: "https://lifelog-kappa.vercel.app",
    },
    {
      title: "CHAT APP",
      description: "Socket.io, React.js, Node.js",
      imgUrl: projImg7,
      github: "https://github.com/ashutoshgithubs/chat-socket",
      link: "https://chat-socket-henna.vercel.app/",
    },
  ];
  const projects3 = [
    {
      title: "Dev Detector",
      description: "HTML5, CSS & JS",
      imgUrl: projImg2,
      github: "https://github.com/ashutoshgithubs/DEV-DETECTIVE",
      link: "https://ashutecher.netlify.app/",
    },
    {
      title: "Weather Web",
      description: "HTML5, Tailwind CSS & JS",
      imgUrl: projImg3,
      github: "https://github.com/ashutoshgithubs/WEATHER-APP",
      link: "https://ashutoshgithubs.github.io/WEATHER-APP/",
    },
    {
      title: "COURSE VERSE",
      description: "React.js & Tailwind CSS ",
      imgUrl: projImg6,
      github: "https://github.com/ashutoshgithubs/CourseVerse",
      link: "https://courseversebyashu.netlify.app/",
    },
    // {
    //   title: "RAZORPAY CLONE",
    //   description: "HTML5, Tailwind CSS",
    //   imgUrl: projImg4,
    //   github: "https://github.com/ashutoshgithubs/Razorpay_Clone_Tailwind",
    //   link: "https://razorpayclonebyashu.netlify.app/",
    // },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Fueling curiosity through code. Dive into the projects that
                    sparked my creativity.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Tab 1</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {projects2.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="third" className="notFound">
                        <img src={notFound} alt="img" />
                      </Tab.Pane> */}
                      <Tab.Pane eventKey="third">
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {projects3.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="img" />
    </section>
  );
};
